import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useFullscreen } from '../hooks/useFullscreen';
import Portal from 'react-overlays/esm/Portal';
import { PreviewSidebar, PreviewDisplay } from './';
import { useLockBodyScroll } from 'react-use';
import { selectIsInfoDialogOpen } from '../redux/slicers/infoDialogSlicer';
import { useSelector } from 'react-redux';
import { isUserOnboardingNonCurator } from '../components/gamificationTooltip/helpers';
import { HIDE_FULL_SCREEN_OPTION_LIST } from "../constants/constants";
import { RemoveWatermark } from '../components/popups/RemoveWatermark';

function Preview({
  id,
  title,
  actions,
  onClose,
  loading,
  updatedAt,
  created_at,
  userName,
  sidebarCards,
  theme,
  sidebarProps,
  previewProps,
  slides,
  activeIndex,
  setActiveIndex,
  activeCameraId,
  activeCameraName,
  setActiveCameraId,
  passOptions,
  pass,
  setPass,
  memberDetails,
  isTransparentBg,
  hideAutoEraseWarning,
  onNextClick,
  onPrevClick,
  hideNextButton,
  hidePrevButton,
  setFullScreenOn,
  isTutorialExperience,
  children,
  isMeasureToolEditable,
  showMeasureTool,
  toggleOffMeasureTool,
  resetLines,
  ...rest
}) {
  const [portalRef, setPortalRef] = useState();
  const { toggle, ref, isFullscreen } = useFullscreen();
  const isInfoDialogOpen = useSelector(selectIsInfoDialogOpen);

  useEffect(() => {
    return (() => {
      setTimeout(() => {
        const bodyTag = document.getElementsByTagName('body')?.[0];
        if(bodyTag?.style?.overflow) bodyTag.style.overflow = null
      },1200)
      setTimeout(() => {
        window.$restrictFilter = null
      },600)
    })
  },[])

  useLockBodyScroll(!isInfoDialogOpen);

  useEffect(() => {
    setPortalRef(document.querySelector('body'));
  }, []);

  useEffect(() => {
    // if(!isFullscreen) return;
    setFullScreenOn?.(isFullscreen);
  }, [isFullscreen])

  const newActions = actions
    ?.map((action) => {
      return action.title === 'Full Screen' // -> it's bad practice -> that's why earlier we used `name` or we can add some boolean instead of checking text
        ? { ...action, clickFunction: toggle }
        : action;
    })
    ?.sort((a, b) => a.seq - b.seq);

  const previewName = `${title}${activeCameraName ? `_${activeCameraName}` : ''}`;

  return (
    <Portal container={portalRef}>
      <div
        style={{
          backgroundColor: '#f9f9f9',
        }}
        ref={ref}>
        <PreviewDisplay
          {...previewProps}
          id={id}
          theme={theme}
          // Hide some options when the user activate fullscreen mode because some off popup not load properly because of fullscreen mode.
          actions={
            !isFullscreen
              ? newActions
              : newActions.filter(({ title }) => !HIDE_FULL_SCREEN_OPTION_LIST?.includes(title)) || []
          }
          isFullscreen={isFullscreen}
          onClose={onClose}
          title={previewName}
          toggleFullscreen={toggle}
          slides={slides}
          cards={sidebarCards}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          activeCameraId={activeCameraId}
          setActiveCameraId={setActiveCameraId}
          passOptions={passOptions}
          pass={pass}
          setPass={setPass}
          isTransparentBg={isTransparentBg}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
          hideNextButton={hideNextButton}
          hidePrevButton={hidePrevButton}
          parentChildren={children}
          loading={loading}
          isTutorialExperience={isTutorialExperience}
          {...rest}
          isMeasureToolEditable={isMeasureToolEditable}
          showMeasureTool={showMeasureTool}
          toggleOffMeasureTool={toggleOffMeasureTool}
          isEditImageTool={rest?.isEditImageTool}
          setIsEditImageTool={rest?.setIsEditImageTool}
          imageToolData={rest?.imageToolData}
          setImageToolData={rest?.setImageToolData}
        />

        {!isFullscreen && !isUserOnboardingNonCurator() && (
          <PreviewSidebar
            {...sidebarProps}
            theme={theme}
            title={title}
            updatedAt={updatedAt}
            created_at={created_at}
            userName={userName}
            cards={sidebarCards}
            isFullscreen={isFullscreen}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            activeCameraId={activeCameraId}
            setActiveCameraId={setActiveCameraId}
            memberDetails={memberDetails}
            loading={loading}
            hideAutoEraseWarning={hideAutoEraseWarning}
            isTransparentBg={isTransparentBg}
            disableClick={hideNextButton && hidePrevButton}
            resetLines={resetLines}
            {...rest}
          />
        )}
      </div>
      {rest?.showPopup && (
          <RemoveWatermark
            onClose={() => {
              rest?.setShowPopup(false);
            }}
            onClick={rest?.onBuyRemoveWatermark}
          />
        )}
    </Portal>
  );
}

export default Preview;
